"use client";

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { WilsonLoader } from "@/components/WilsonLoader";
import { Button } from "./ui/Button";
interface ErrorStateProps {
  title: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
  secondaryAction?: ReactNode;
  animation?: string;
  variant?: "page" | "inline";
  className?: string;
}
export function ErrorState({
  title,
  description,
  onRetry,
  retryLabel = "Try again",
  secondaryAction,
  animation = "toaster",
  variant = "page",
  className
}: ErrorStateProps) {
  if (variant === "inline") {
    return <div className={cn("flex items-center gap-3", className)} role="alert">
                <span className="text-sm text-ink-2">{title}</span>
                {onRetry && <Button variant="secondary" size="sm" onClick={onRetry}>
                        {retryLabel}
                    </Button>}
            </div>;
  }
  return <div className={cn("flex h-full flex-col items-center justify-center gap-1.5 px-6 text-center", className)} role="alert" data-sentry-component="ErrorState" data-sentry-source-file="ErrorState.tsx">
            <WilsonLoader size="lg" animation={animation} data-sentry-element="WilsonLoader" data-sentry-source-file="ErrorState.tsx" />
            <p className="text-title font-normal leading-tight tracking-[-0.01em] text-ink">
                {title}
            </p>
            {description && <p className="max-w-[42ch] text-balance text-sm text-ink-2">
                    {description}
                </p>}
            {(onRetry || secondaryAction) && <div className="mt-1.5 flex flex-wrap justify-center gap-2">
                    {secondaryAction}
                    {onRetry && <Button variant="secondary" size="sm" onClick={onRetry}>
                            {retryLabel}
                        </Button>}
                </div>}
        </div>;
}